import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router';
import { useIotsApi } from '../../../contexts/iotsApi';
import { useLanguage } from '../../../contexts/language';
import { disableNavigationGuard } from '../../../hooks/useNavigationGuard';
import VesselForm from './VesselForm';
import useApiErrorMessageGetter from '../../../hooks/useApiErrorMessage';

const CreateVesselPage = () => {
  const { createVessel } = useIotsApi();
  const { t } = useLanguage();
  const mutation = useMutation({ mutationFn: createVessel });
  const { enqueueSnackbar } = useSnackbar();
  const getErrorMessage = useApiErrorMessageGetter();
  const navigate = useNavigate();

  return (
    <VesselForm
      vessel={null}
      isLoading={mutation.isPending}
      onSubmit={values => {
        mutation.mutate(values, {
          onSuccess: id => {
            enqueueSnackbar({
              variant: 'success',
              message: t('content.vessel-creation-success'),
            });
            void disableNavigationGuard(() => navigate(`/admin/vessels/${id}`));
          },
          onError: error => {
            enqueueSnackbar({
              variant: 'error',
              message: getErrorMessage(
                error,
                t('content.vessel-creation-error'),
              ),
            });
            mutation.reset();
          },
        });
      }}
      onCancel={() => void navigate('/admin/vessels')}
    />
  );
};

export default CreateVesselPage;
